
<template>
  <div id="content"  v-show="!loading">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <form autocomplete="off">
      <div class="inner">
        <p class="paging">
          <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
        </p>
        <p class="buttons">
        <a v-if="$_deleteActionAllowed" class="btn btn_action btn_delete" :title="'Smazat' | translate"
           @click.prevent.stop="deleteEntity" v-translate>Smazat</a>
      </p>
        <h1 v-translate>Detail inicializačního procesu zařízení</h1>
      </div>
      <div class="responsiveTabs">
        <div class="tabs_content">
            <basic-settings
                :is-update="true"
                :entity="entity"
                :is-editable="$_updateActionAllowed"
                :brand-options="brandOptions"
                :device-type-options="deviceTypeOptions"
                ref="basicsettingsref"
            ></basic-settings>
          <welcome-screen-settings
              :entity="entity"
              :keys-options="this.keysOptions"
              :is-editable="$_updateActionAllowed"
              ref="welcomescreensettingsref"
          >
          </welcome-screen-settings>
          <default-pairing-screen
              :entity="entity"
              :is-editable="$_updateActionAllowed"
              ref="defaultpairingscreenref"
          >
          </default-pairing-screen>
          <failed-pairing-screen
              :entity="entity"
              :is-editable="$_updateActionAllowed"
              ref="failedpairingscreenref"
          >
          </failed-pairing-screen>
          <promo-screen
              :entity="entity"
              :is-editable="$_updateActionAllowed"
              ref="promoscreenref"
          />
          <languages
              :entity="entity"
              :is-editable="$_updateActionAllowed"
              :language-options="languageOptions"
              ref="promoscreenref"
          />
          <section class="buttons">
            <p>
              <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam
              </router-link>
              <input type="submit" :value="'Uložit' | translate"
                     v-if="$_updateActionAllowed"
                     :class="['btn']"
                     @click.prevent.stop="submitForm()">
            </p>
          </section>
        </div>
      </div>
    </form>
  </div>
</template>

<script>

import detailActions from "../../../components/mixins/detail-actions"
import initialProcessSetup from "./mixins/InitialProcessSetup";
import BasicSettings from "./forms/BasicSettings.vue";
import WelcomeScreenSettings from "./forms/WelcomeScreenSettings.vue";
import DefaultPairingScreen from "./forms/DefaultPairingScreen.vue";
import FailedPairingScreen from "./forms/FailedPairingScreen.vue";
import PromoScreen from "./forms/PromoScreen.vue";
import Languages from "./forms/Languages.vue";

export default {
  name: "InitialProcessSetupDetail",
  components: {Languages, PromoScreen, FailedPairingScreen, DefaultPairingScreen, WelcomeScreenSettings, BasicSettings},
  mixins: [detailActions, initialProcessSetup],
  data() {
    return {
      entityName: "initial_process_setup"
    }
  },
  created(InitialProcessSetupService, DeviceTypeService, BrandService) {
    this.entityService = InitialProcessSetupService;
    this.deviceTypeService = DeviceTypeService;
    this.brandService = BrandService;
    this.createdInit();
    this.getBrands();
    this.getDeviceTypes();
    this.getSettings();
  },
  computed: {}
}
</script>



// WEBPACK FOOTER //
// src/components/views/initialProcessSetup/InitialProcessSetupDetail.vue